import React, { FunctionComponent } from 'react';
import { EventShareButtonsProps } from './types';
import { ShareButton } from '../../atoms/shareButton';

export const Presentation: FunctionComponent<EventShareButtonsProps> = ({ eventTitle, eventUrl }) => {
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}`;
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(eventTitle)}&url=${encodeURIComponent(eventUrl)}`;

  return (
    <aside className="p-article-share-buttons">
      <div className="p-article-share-buttons__inner">
        <h2 className="p-article-share-buttons__heading">イベントをシェア</h2>
        <div className="p-article-share-buttons-box">
          <ul className="p-article-share-buttons__list">
            <ShareButton platform="facebook" label="シェアする" url={facebookUrl} />
            <ShareButton platform="twitter" label="ツイートする" url={twitterUrl} />
          </ul>
        </div>
      </div>
    </aside>
  );
};
